import * as actionTypes from './actionTypes';

export const loading = () => ({
    type: actionTypes.LOADING
});

export const loaded = () => ({
    type: actionTypes.LOADED
});

export const error = error => ({
    type: actionTypes.ERROR,
    error
});

export const addGroup = (group) => ({
    type: actionTypes.ADD_GROUP,
    group
});

export const addPost = post => ({
    type: actionTypes.ADD_POST,
    post
});

export const removePost = post => ({
    type: actionTypes.REMOVE_POST,
    post
});

export const modifyPost = post => ({
    type: actionTypes.MODIFY_POST,
    post
});
